import React from 'react';
import PageView from '../components/sections/PageView';

const StoryPage = () => <PageView slug="our_story" />;

export default StoryPage;
